import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { useMediaQuery, IconButton, Avatar, Box, Menu, AppBar, alpha, Container, Toolbar, Dialog, DialogTitle, DialogContent, DialogActions, Button, Drawer, Popover, Paper, MenuList, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import uniqueId from 'lodash.uniqueid';
import { Close, AccountCircle } from '@mui/icons-material';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function useIsWidthUp(breakpoint) {
    var theme = useTheme();
    return useMediaQuery(theme.breakpoints.up(breakpoint));
}
function useIsWidthDown(breakpoint) {
    var theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(breakpoint));
}
/**
 * Be careful using this hook. It only works because the number of
 * breakpoints in theme is static. It will break once you change the number of
 * breakpoints. See https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
 */
function useWidth() {
    var theme = useTheme();
    var keys = __spreadArray([], theme.breakpoints.keys, true).reverse();
    return (
    // @ts-ignore
    keys.reduce(function (output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
    }, null) || 'xs');
}

/**
 * Created by jacob.mendt@pikobytes.de on 27.05.22.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
// @ts-nocheck
function NavDropDown(props) {
    var _a = props.CarotProps, CarotProps = _a === void 0 ? { right: 14 } : _a, DropdownContent = props.DropdownContent, IconClose = props.IconClose, IconOpen = props.IconOpen, _b = props.MenuAnchorOriginProps, MenuAnchorOriginProps = _b === void 0 ? {} : _b, _c = props.MenuTransformOriginProps, MenuTransformOriginProps = _c === void 0 ? {} : _c, _d = props.sxButton, sxButton = _d === void 0 ? {} : _d, _e = props.sxMenu, sxMenu = _e === void 0 ? {} : _e;
    var _f = useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var idMenu = "nav-dropdown-".concat(uniqueId());
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { className: "pb-components-navdropdown-btn", onClick: handleClick, size: "small", sx: Object.assign({ ml: 2 }, sxButton), "aria-controls": open ? { idMenu: idMenu } : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, disableRipple: true },
            (IconOpen !== undefined && !open) && (IconOpen),
            (IconClose !== undefined && open) && (IconClose),
            ((IconOpen === undefined && !open) || (IconClose === undefined && open)) && (React.createElement(React.Fragment, null,
                React.createElement(Avatar, { sx: { width: 32, height: 32 } }),
                React.createElement(Box, { sx: { width: 32, height: 32 } },
                    React.createElement(ArrowDropDownIcon, null))))),
        React.createElement(Menu, { className: "pb-components-navdropdown-menu", anchorEl: anchorEl, id: idMenu, open: open, onClose: handleClose, onClick: handleClose, PaperProps: {
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&:before': Object.assign({
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    }, CarotProps),
                },
            }, 
            // @ts-ignore
            transformOrigin: Object.assign({ horizontal: 'right', vertical: 'top' }, MenuTransformOriginProps), 
            // @ts-ignore
            anchorOrigin: Object.assign({ horizontal: 'center', vertical: 'bottom' }, MenuAnchorOriginProps), sx: sxMenu }, DropdownContent)));
}

/**
 * Created by jacob.mendt@pikobytes.de on 27.05.22.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
/**
 * @param {AppHeaderProps} props
 */
function AppHeader(props) {
    props.children; var _a = props.className, className = _a === void 0 ? '' : _a, _b = props.shouldChangeOnScroll, shouldChangeOnScroll = _b === void 0 ? false : _b, NavElementRight = props.NavElementRight, NavLinks = props.NavLinks, Logo = props.Logo, _c = props.sx, sx = _c === void 0 ? {} : _c;
    var containerRef = useRef(null);
    var _d = useState(shouldChangeOnScroll), isVisible = _d[0], setIsVisible = _d[1];
    var isMdUp = useIsWidthUp('md');
    // Enable shouldChangeOnScroll behavior
    if (shouldChangeOnScroll) {
        var handleScroll_1 = function () {
            if (containerRef.current !== null) {
                var _a = containerRef.current.getBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom;
                var isVisible_1 = top_1 >= -300 && bottom <= window.innerHeight;
                setIsVisible(isVisible_1);
            }
        };
        useEffect(function () {
            window.addEventListener('scroll', handleScroll_1);
            return function () {
                window.removeEventListener('scroll', handleScroll_1);
            };
        }, []);
    }
    return (React.createElement(Box, { className: clsx('pb-components-appheader', className), ref: containerRef, sx: Object.assign({
            flexGrow: 1
        }, sx) },
        React.createElement(AppBar, { sx: Object.assign({
                backgroundColor: function (theme) { return alpha(theme.palette.primary.dark, 0.9); },
                color: 'primary.contrastText',
            }, (shouldChangeOnScroll && isVisible) ? {
                backgroundColor: 'transparent',
                boxShadow: 'none !important',
                '& a': { color: '#fff !important' },
                '& svg': { color: '#fff !important' },
                '& .MuiButtonBase-root': { color: '#fff !important' }
            } : {}) },
            React.createElement(Container, { sx: {
                    paddingLeft: 0,
                    paddingRight: 0,
                } },
                React.createElement(Toolbar, { sx: {
                        height: {
                            xs: 70,
                            sm: 90
                        },
                        // Default style for links
                        '& a': {
                            color: function (theme) { return theme.palette.primary.contrastText; },
                            boxShadow: 'none',
                            textDecoration: 'none',
                            lineHeight: 1.5,
                            fontSize: 14,
                            mx: 1,
                            py: 1,
                            px: 1.5,
                        },
                        "& a:hover": {
                            transform: 'scale(1.2)',
                        }
                    } },
                    isMdUp && (React.createElement(React.Fragment, null,
                        React.createElement(Box, { sx: { flexGrow: 1 } }, Logo),
                        React.createElement(Box, { sx: {} }, NavLinks),
                        React.createElement(Box, null, NavElementRight))),
                    !isMdUp && (React.createElement(React.Fragment, null,
                        React.createElement(NavDropDown, { CarotProps: { left: 14 }, DropdownContent: NavLinks, IconClose: React.createElement(CloseIcon, { sx: { color: "#fff" } }), IconOpen: React.createElement(MenuIcon, { sx: { color: "#fff" } }), MenuAnchorOriginProps: { vertical: "bottom", horizontal: "left" }, MenuTransformOriginProps: { vertical: "top", horizontal: "left" }, sxButton: { mr: 2 } }),
                        React.createElement(Box, { sx: { flexGrow: 1 } }, Logo),
                        React.createElement(Box, null, NavElementRight))))))));
}

/**
 * Created by jacob.mendt@pikobytes.de on 03.03.22.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
function setCookie(cookieName, cookieValue, expireDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
    document.cookie = "".concat(cookieName, "=").concat(cookieValue, ";expires=").concat(d.toUTCString(), ";path=/");
}
function getCookie(cookieName) {
    var name = "".concat(cookieName, "=");
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function removeCookie(cookieName) {
    document.cookie = "".concat(cookieName, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/");
}

/**
 * Created by jacob.mendt@pikobytes.de on 03.03.22.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
// Logic for setting the cookie
var COOKIE_NAME = 'pikobytes-cookie-consent';
var COOKIE_VALUES = {
    ALLOW_ALL: 'allow-all',
    ALLOW_ONLY_NECESSARY: 'allow-only-necessary'
};
/**
 * @param {CookieConsentProps} props
 */
function CookieConsent(props) {
    var _a = props.className, className = _a === void 0 ? '' : _a, children = props.children, _b = props.cookieName, cookieName = _b === void 0 ? COOKIE_NAME : _b, _c = props.labelBtnAllowAll, labelBtnAllowAll = _c === void 0 ? 'Allow all Cookies' : _c, _d = props.labelBtnAllowOnlyNecssary, labelBtnAllowOnlyNecssary = _d === void 0 ? 'Allow necessary Cookies' : _d, 
    // Number of days in which the cookie should expire. Default is 730 days.
    _e = props.maxCookieLifetimeDays, 
    // Number of days in which the cookie should expire. Default is 730 days.
    maxCookieLifetimeDays = _e === void 0 ? 365 * 2 : _e, _f = props.onAllowAllCookies, onAllowAllCookies = _f === void 0 ? function () { return console.warn('The function \'onAllowCookies\' is not passed to the property.'); } : _f, _g = props.onAllowOnlyNecessaryCookies, onAllowOnlyNecessaryCookies = _g === void 0 ? function () { return console.warn('The function \'onAllowOnlyNecessaryCookies\' is not passed to the property.'); } : _g, _h = props.sx, sx = _h === void 0 ? {} : _h, _j = props.title, title = _j === void 0 ? 'This Website uses cookies' : _j;
    var ariaLabelledBy = 'cookie-consent-dialog-title';
    var ariaDescribedBy = 'cookie-consent-dialog-description';
    // Handler for allow all cookies
    var handleAllowAllCookies = function () {
        setCookie(cookieName, COOKIE_VALUES.ALLOW_ALL, maxCookieLifetimeDays);
        // Trigger callback
        onAllowAllCookies();
    };
    // Handler for allow only necessary cookies
    var handleAllowOnlyNecessaryCookies = function () {
        setCookie(cookieName, COOKIE_VALUES.ALLOW_ONLY_NECESSARY, maxCookieLifetimeDays);
        // Trigger callback
        onAllowOnlyNecessaryCookies();
    };
    return (React.createElement(Dialog, { className: clsx('pb-components-cookie-consent', className), open: true, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, sx: sx },
        React.createElement(DialogTitle, { id: ariaLabelledBy, sx: {
                textTransform: 'uppercase'
            } }, title),
        React.createElement(DialogContent, { id: ariaDescribedBy }, children),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleAllowAllCookies, color: 'primary', variant: 'contained' }, labelBtnAllowAll),
            React.createElement(Button, { onClick: handleAllowOnlyNecessaryCookies, variant: 'outlined' }, labelBtnAllowOnlyNecssary))));
}

/**
 * Created by jacob.mendt@pikobytes.de on 25.02.22.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
/**
 * @param {PanelProps} props
 */
function Panel(props) {
    var children = props.children, _a = props.className, className = _a === void 0 ? '' : _a, _b = props.isOpen, isOpen = _b === void 0 ? true : _b, _c = props.labelClose, labelClose = _c === void 0 ? 'Close' : _c, _d = props.onClose, onClose = _d === void 0 ? function () { return console.warn('onClose is not implemented yet.'); } : _d, _e = props.sx, sx = _e === void 0 ? {} : _e;
    return (React.createElement(Drawer, { className: clsx('pb-components-panel', className), anchor: 'right', open: isOpen, onClose: onClose, PaperProps: {
            sx: { overflow: 'hidden' },
        }, sx: sx },
        React.createElement(Box, null,
            React.createElement(Button, { endIcon: React.createElement(Close, null, labelClose), onClick: onClose, sx: {
                    m: 1,
                    float: 'right',
                    cursor: 'pointer',
                } }, labelClose)),
        React.createElement(Box, { role: 'presentation', onClick: onClose, onKeyDown: onClose, sx: {
                width: 250
            } }, children)));
}

/**
 * Created by jacob.mendt@pikobytes.de on 28.02.22.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
/**
 * @param {SidePanelProps} props
 */
function SidePanel(props) {
    var children = props.children, _a = props.classNameButton, classNameButton = _a === void 0 ? '' : _a, _b = props.classNamePanel, classNamePanel = _b === void 0 ? '' : _b, _c = props.sxButton, sxButton = _c === void 0 ? Object : _c, _d = props.sxPanel, sxPanel = _d === void 0 ? Object : _d;
    var _e = React.useState(false), showDrawer = _e[0], setShowDrawer = _e[1];
    var handleToggleDrawer = function (open) { return function (event) {
        if (event.type === 'keydown' &&
            (event.key === 'Tab' ||
                event.key === 'Shift')) {
            return;
        }
        setShowDrawer(open);
    }; };
    return (React.createElement(Box, { className: 'pb-components-sidepanel' },
        React.createElement(IconButton, { edge: 'start', className: classNameButton, color: 'inherit', "aria-label": 'open side panel', onClick: handleToggleDrawer(true), size: 'large', sx: Object.assign({
                color: 'primary.contrastText',
                backgroundColor: 'primary.main',
                mr: {
                    xs: 0,
                    sm: 2
                },
                '&:hover': {
                    opacity: 1,
                    cursor: 'pointer',
                    backgroundColor: 'primary.dark',
                },
                '&:hover svg': {
                    transform: 'scale(1.1)'
                },
            }, sxButton) },
            React.createElement(MenuIcon, null)),
        React.createElement(Panel, { className: classNamePanel, isOpen: showDrawer, onClose: handleToggleDrawer(false), sx: Object.assign({
                // Default style for links
                '& a': {
                    color: '#000000',
                    display: 'block',
                    boxShadow: 'none',
                    textDecoration: 'none',
                    lineHeight: 1.5,
                    fontSize: 14,
                    mx: 1,
                    px: 1.5,
                    py: 1,
                },
            }, sxPanel) }, children)));
}

// Style definitions
var buttonDefault = {
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
    '&:hover': {
        opacity: 1,
        cursor: 'pointer',
        backgroundColor: 'primary.dark',
    },
};
var buttonRaw = {
    width: function (theme) { return theme.spacing(5); },
    height: function (theme) { return theme.spacing(5); },
};
var buttonNotRaw = {
    height: 40,
    fontWeight: 600,
};
function UserLogin(props) {
    var children = props.children, _a = props.className, className = _a === void 0 ? '' : _a, isAuthenticated = props.isAuthenticated, _b = props.labelLogin, labelLogin = _b === void 0 ? 'Login' : _b, _c = props.labelLogout, labelLogout = _c === void 0 ? 'Logout' : _c, _d = props.labelSignIn, labelSignIn = _d === void 0 ? 'Sign in' : _d, _e = props.muiPopoverProps, muiPopoverProps = _e === void 0 ? { anchorOrigin: { horizontal: 'left', vertical: 'bottom' } } : _e, _f = props.onLogin, onLogin = _f === void 0 ? function () { return console.warn('Function \'onLogin\' is called by the UserLogin component, but is not implemented yet.'); } : _f, _g = props.onLogout, onLogout = _g === void 0 ? function () { return console.warn('Function \'onLogout\' is called by the UserLogin component, but is not implemented yet.'); } : _g, _h = props.raw, raw = _h === void 0 ? false : _h, _j = props.sx, sx = _j === void 0 ? {} : _j, _k = props.username, username = _k === void 0 ? '' : _k;
    var _l = useState(false), menuOpen = _l[0], setMenuOpen = _l[1];
    var AvatarRef = useRef(null);
    var handleCloseMenu = function () {
        setMenuOpen(false);
    };
    var handleOpenMenu = function () {
        setMenuOpen(true);
    };
    var handleLogout = function () {
        onLogout();
        handleCloseMenu();
    };
    var handleLogin = function () {
        onLogin();
        handleCloseMenu();
    };
    if (raw) {
        return (React.createElement(Box, { className: clsx('pb-components-userlogin', className), sx: sx },
            React.createElement(IconButton, { "aria-label": 'user-menu', disableRipple: true, onClick: isAuthenticated ? handleOpenMenu : handleLogin, color: 'primary', ref: AvatarRef, size: 'large', sx: Object.assign({}, buttonDefault, buttonRaw) },
                React.createElement(AccountCircle, { fontSize: 'inherit' }))));
    }
    return (React.createElement(Box, { className: clsx('pb-components-userlogin', className), sx: sx },
        isAuthenticated && (React.createElement(Avatar, { onClick: handleOpenMenu, ref: AvatarRef, sx: {
                color: 'primary.contrastText',
                backgroundColor: 'primary.main',
                transition: function (theme) { return theme.transitions.create(['background-color', 'transform'], {
                    duration: theme.transitions.duration.enteringScreen,
                }); },
                '&:hover': {
                    opacity: 1,
                    cursor: 'pointer',
                    backgroundColor: 'primary.dark',
                },
            } }, username.length > 0 ? username[0].toUpperCase() : 'U')),
        !isAuthenticated && (React.createElement(Button, { "aria-label": 'sign-in', color: 'primary', disableRipple: true, onClick: handleLogin, startIcon: React.createElement(AccountCircle, null), sx: Object.assign({}, buttonDefault, buttonNotRaw), variant: 'contained' }, labelSignIn.toUpperCase())),
        React.createElement(Popover, __assign({ anchorEl: AvatarRef.current, id: 'pb-userlogin-menu', keepMounted: true, open: menuOpen, onClose: handleCloseMenu }, muiPopoverProps),
            React.createElement(Paper, null,
                React.createElement(MenuList, { dense: true },
                    children,
                    isAuthenticated ? (React.createElement(MenuItem, { onClick: handleLogout }, labelLogout)) : (React.createElement(MenuItem, { onClick: handleLogin }, labelLogin)))))));
}

export { AppHeader, COOKIE_NAME, COOKIE_VALUES, CookieConsent, NavDropDown, SidePanel, UserLogin, getCookie, removeCookie, setCookie, useIsWidthDown, useIsWidthUp, useWidth };
//# sourceMappingURL=index.js.map
